/* ============================================================
   STADIUMFORGE — theme.js
   Cart drawer + AJAX cart + BOGO progress + shipping protection
   ============================================================ */
(function () {
  "use strict";

  var CFG = window.SF_CONFIG || {};
  var TABLE_PRICE = 15000; // cents, used only for progress messaging
  var SP_VARIANT = CFG.shippingProtectionVariantId || null;
  var SP_ENABLED = CFG.shippingProtectionEnabled;
  var BOGO_ENABLED = CFG.bogoEnabled;

  var money = function (cents) {
    return "$" + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  /* ---------- DOM refs ---------- */
  var overlay = document.querySelector("[data-drawer-overlay]");
  var drawer = document.querySelector("[data-cart-drawer]");
  var drawerBody = document.querySelector("[data-drawer-body]");
  var drawerFoot = document.querySelector("[data-drawer-foot]");
  var cartCountEls = document.querySelectorAll("[data-cart-count]");

  /* ---------- Cart state fetch ---------- */
  function getCart() {
    return fetch("/cart.js", { headers: { "Content-Type": "application/json" } }).then(function (r) {
      return r.json();
    });
  }

  function updateCount(cart) {
    // exclude shipping protection from the item count shown
    var count = 0;
    cart.items.forEach(function (i) {
      if (String(i.variant_id) !== String(SP_VARIANT)) count += i.quantity;
    });
    cartCountEls.forEach(function (el) {
      el.textContent = count;
      el.classList.toggle("hide", count === 0);
    });
    return count;
  }

  /* ---------- Add to cart ---------- */
  function addToCart(variantId, qty) {
    qty = qty || 1;
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: Number(variantId), quantity: qty })
    }).then(function (r) {
      return r.json();
    });
  }

  function changeLine(key, qty) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) {
      return r.json();
    });
  }

  /* ---------- Count tables (not protection) ---------- */
  function countTables(cart) {
    var n = 0;
    cart.items.forEach(function (i) {
      if (String(i.variant_id) !== String(SP_VARIANT)) n += i.quantity;
    });
    return n;
  }

  function hasProtection(cart) {
    return cart.items.some(function (i) {
      return String(i.variant_id) === String(SP_VARIANT);
    });
  }

  /* ---------- Render drawer ---------- */
  function renderDrawer(cart) {
    var tables = countTables(cart);
    var html = "";

    /* BOGO progress */
    if (BOGO_ENABLED) {
      var pct, msg, unlocked;
      if (tables <= 0) {
        pct = 0; unlocked = false;
        msg = "Add a table to start your deal";
      } else if (tables === 1) {
        pct = 50; unlocked = false;
        msg = "You're 1 table away from 50% off";
      } else {
        pct = 100; unlocked = true;
        msg = "Unlocked — 2nd table is 50% off";
      }
      html +=
        '<div class="bogo-progress">' +
          '<div class="bogo-progress__msg ' + (unlocked ? "is-unlocked" : "") + '">' +
            '<span class="ico">' + (unlocked ? "\u2713" : "\u26A1") + '</span>' +
            '<span>' + msg + '</span>' +
          "</div>" +
          '<div class="bogo-progress__track"><div class="bogo-progress__fill" style="width:' + pct + '%"></div></div>' +
        "</div>";
    }

    if (!cart.items.length) {
      html += '<div class="cart-empty"><p>Your cart is empty.</p><a href="#configurator" class="btn btn--primary" data-drawer-close>Build your table \u2192</a></div>';
      drawerBody.innerHTML = html;
      drawerFoot.classList.add("hide");
      return;
    }

    /* Line items */
    cart.items.forEach(function (item) {
      if (String(item.variant_id) === String(SP_VARIANT)) return; // render protection separately
      html +=
        '<div class="line-item" data-line-key="' + item.key + '">' +
          '<img class="line-item__img" src="' + (item.image ? item.image.replace(/(\.[^.]+)(\?.*)?$/, "_120x120$1$2") : "") + '" alt="">' +
          '<div class="line-item__info">' +
            '<div class="line-item__title">' + item.product_title + "</div>" +
            '<div class="line-item__variant">' + (item.variant_title && item.variant_title !== "Default Title" ? item.variant_title : "") + "</div>" +
            '<div class="line-item__qty">' +
              '<button data-qty-dec aria-label="Decrease">\u2212</button>' +
              "<span>" + item.quantity + "</span>" +
              '<button data-qty-inc aria-label="Increase">+</button>' +
            "</div>" +
            '<button class="line-item__remove" data-remove>Remove</button>' +
          "</div>" +
          '<div class="line-item__price">' + money(item.final_line_price) + "</div>" +
        "</div>";
    });

    /* Shipping protection toggle */
    if (SP_ENABLED && SP_VARIANT) {
      var on = hasProtection(cart);
      html +=
        '<div class="ship-protect">' +
          '<div class="ship-protect__ico">\u{1F6E1}</div>' +
          '<div class="ship-protect__txt">' +
            '<div class="ship-protect__t">Shipping Protection</div>' +
            '<div class="ship-protect__d">Covers loss, theft & damage in transit \u2014 ' + (CFG.shippingProtectionPrice || "$10.00") + "</div>" +
          "</div>" +
          '<label class="switch">' +
            '<input type="checkbox" data-ship-protect ' + (on ? "checked" : "") + ">" +
            '<span class="switch__slider"></span>' +
          "</label>" +
        "</div>";
    }

    drawerBody.innerHTML = html;

    /* Footer */
    drawerFoot.classList.remove("hide");
    var note = BOGO_ENABLED
      ? '<div class="cart-drawer__note">BOGO 50% is applied automatically at checkout when 2+ tables are in your cart.</div>'
      : "";
    drawerFoot.innerHTML =
      '<div class="cart-drawer__subtotal"><span class="lbl">Subtotal</span><span class="val">' + money(cart.total_price) + "</span></div>" +
      '<div class="cart-drawer__note">Free shipping \u00B7 Ships in 1\u20132 weeks \u00B7 Taxes at checkout</div>' +
      note +
      '<a href="/checkout" class="btn btn--primary btn--block btn--lg">Secure Checkout \u2192</a>';

    bindDrawerEvents();
  }

  function refresh(open) {
    return getCart().then(function (cart) {
      updateCount(cart);
      renderDrawer(cart);
      if (open) openDrawer();
      return cart;
    });
  }

  /* ---------- Drawer open/close ---------- */
  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add("is-open");
    overlay.classList.add("is-open");
    document.body.style.overflow = "hidden";
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove("is-open");
    overlay.classList.remove("is-open");
    document.body.style.overflow = "";
  }

  /* ---------- Drawer inner events ---------- */
  function bindDrawerEvents() {
    drawerBody.querySelectorAll(".line-item").forEach(function (li) {
      var key = li.getAttribute("data-line-key");
      var cur = parseInt(li.querySelector(".line-item__qty span").textContent, 10);
      li.querySelector("[data-qty-inc]").addEventListener("click", function () {
        changeLine(key, cur + 1).then(function (cart) { updateCount(cart); renderDrawer(cart); });
      });
      li.querySelector("[data-qty-dec]").addEventListener("click", function () {
        changeLine(key, Math.max(0, cur - 1)).then(function (cart) { updateCount(cart); renderDrawer(cart); });
      });
      li.querySelector("[data-remove]").addEventListener("click", function () {
        changeLine(key, 0).then(function (cart) { updateCount(cart); renderDrawer(cart); });
      });
    });

    var sp = drawerBody.querySelector("[data-ship-protect]");
    if (sp) {
      sp.addEventListener("change", function () {
        if (sp.checked) {
          addToCart(SP_VARIANT, 1).then(function () { refresh(false); });
        } else {
          getCart().then(function (cart) {
            var line = cart.items.find(function (i) { return String(i.variant_id) === String(SP_VARIANT); });
            if (line) changeLine(line.key, 0).then(function (c) { updateCount(c); renderDrawer(c); });
          });
        }
      });
    }

    drawerBody.querySelectorAll("[data-drawer-close]").forEach(function (b) {
      b.addEventListener("click", closeDrawer);
    });
  }

  /* ---------- Global bindings ---------- */
  if (overlay) overlay.addEventListener("click", closeDrawer);
  document.querySelectorAll("[data-cart-toggle]").forEach(function (b) {
    b.addEventListener("click", function (e) { e.preventDefault(); refresh(true); });
  });
  var closeBtn = document.querySelector("[data-drawer-close-btn]");
  if (closeBtn) closeBtn.addEventListener("click", closeDrawer);
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeDrawer(); });

  /* ---------- Expose add-to-cart for configurator ---------- */
  window.SF = {
    addTable: function (variantId) {
      return addToCart(variantId, 1).then(function () { return refresh(true); });
    },
    refresh: refresh
  };

  /* ---------- Init ---------- */
  document.addEventListener("DOMContentLoaded", function () {
    refresh(false);
  });
})();

/* ============================================================
   CONFIGURATOR
   ============================================================ */
(function () {
  "use strict";
  var root = document.querySelector("[data-configurator]");
  if (!root) return;

  var data = JSON.parse(root.getAttribute("data-variants") || "[]");
  var confSel = root.querySelector("[data-conf-toggle]");
  var teamSel = root.querySelector("[data-team-select]");
  var addBtn = root.querySelector("[data-cfg-add]");
  var badge = root.querySelector("[data-cfg-badge]");
  var nameEl = root.querySelector("[data-cfg-name]");
  var previewTag = root.querySelector("[data-cfg-preview]");
  var imgEl = root.querySelector("[data-cfg-img]");
  var glowEl = root.querySelector("[data-cfg-glow]");
  var soldEl = root.querySelector("[data-cfg-soldout]");

  var currentConf = "AFC";

  function initials(name) {
    var stop = { "the": 1, "of": 1 };
    var words = name.split(" ").filter(function (w) { return !stop[w.toLowerCase()]; });
    var last = words[words.length - 1] || name;
    return last.substring(0, 2).toUpperCase();
  }

  function populate() {
    teamSel.innerHTML = "";
    var list = data.filter(function (v) { return v.conference === currentConf || v.conference === "ANY"; });
    // custom + available first ordering already set in data
    list.forEach(function (v) {
      var opt = document.createElement("option");
      opt.value = v.id;
      opt.textContent = v.name + (v.available ? "" : " (Sold out)");
      opt.disabled = !v.available;
      opt.dataset.color = v.color;
      opt.dataset.name = v.name;
      opt.dataset.image = v.image || "";
      teamSel.appendChild(opt);
    });
    // select first available
    var firstAvail = list.find(function (v) { return v.available; });
    if (firstAvail) teamSel.value = firstAvail.id;
    sync();
  }

  function sync() {
    var opt = teamSel.options[teamSel.selectedIndex];
    if (!opt) return;
    var color = opt.dataset.color || "#e8802b";
    var name = opt.dataset.name || "";
    var image = opt.dataset.image || "";
    root.style.setProperty("--team", color);
    if (badge) badge.textContent = initials(name);
    if (nameEl) nameEl.textContent = name + " Edition";
    if (previewTag) previewTag.innerHTML = "Preview: <b>" + name.toUpperCase() + "</b>";
    if (image && imgEl) imgEl.src = image;
    addBtn.setAttribute("data-variant-id", opt.value);
    var disabled = opt.disabled;
    addBtn.disabled = disabled;
    addBtn.style.opacity = disabled ? "0.5" : "1";
    addBtn.style.pointerEvents = disabled ? "none" : "auto";
  }

  if (confSel) {
    confSel.querySelectorAll("button").forEach(function (b) {
      b.addEventListener("click", function () {
        confSel.querySelectorAll("button").forEach(function (x) { x.classList.remove("is-active"); });
        b.classList.add("is-active");
        currentConf = b.getAttribute("data-conf");
        populate();
      });
    });
  }

  if (teamSel) teamSel.addEventListener("change", sync);

  if (addBtn) {
    addBtn.addEventListener("click", function () {
      var vid = addBtn.getAttribute("data-variant-id");
      if (!vid) return;
      var label = addBtn.querySelector("[data-add-label]");
      var orig = label ? label.textContent : "";
      if (label) label.textContent = "Adding\u2026";
      window.SF.addTable(vid).then(function () {
        if (label) label.textContent = orig;
      }).catch(function () {
        if (label) label.textContent = orig;
      });
    });
  }

  populate();
})();
